export default "__VITE_PUBLIC_ASSET__ab3fe29c__"